import {css} from 'lit'; export default css`.filter-type-icon{border-radius:6px;width:21px;height:21px;display:flex;align-items:center;justify-content:center;background:#dee3ec}`;
    